<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="filterCodigoIntegracaoErp" class="col-form-label">Código ERP</label>
                <input type="text" class="form-control" [(ngModel)]="filter.codigoIntegracaoErp" name="filterCodigoIntegracaoERp" id="filterCodigoIntegracaoErp"
                    (ngModelChange)="isFilterDirty = true;">
            </div>
            <div class="form-group col-12 col-md-4">
                <label for="filterSituacao" class="col-form-label">Situação</label>
                <select class="form-control" name="situacao" id="situacao" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true"
                    #filterSituacao="ngModel">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>                                        
            </div>                        
        </div>
        <div class="row">
            <div class="form-group col-12 col-md" *ngIf="configItem?.exibirCliente">
                <label for="filterPessoa" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente-pessoa [(ngModel)]="filter.pessoa" name="filterPessoa" id="filterPessoa"
                    #filterPessoa="ngModel" [ngControl]="filterPessoa"
                    (typeaheadChange)="onChangeCliente($event)">
                </sgt-typeahead-cliente-pessoa>                                  
            </div>
            <div class="form-group col-12 col-md" *ngIf="!isRepresentante">
                <label for="filterRepresentante" class="col-form-label">Representante</label>
                <sgt-typeahead-representante [(ngModel)]="filter.representante" name="filterRepresentante" id="filterRepresentante"
                    #filterRepresentante="ngModel" [ngControl]="filterRepresentante"
                    (typeaheadChange)="onChangeRepresentante($event)">
                </sgt-typeahead-representante>                                                                  
            </div>    
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-4" *ngIf="isTipoMercadoMarca()">
                <label for="filterItemMarca" class="col-form-label">Marca</label>
                <select class="form-control" name="filterItemMarca" id="filterItemMarca" 
                    [ngModel]="filter.idItemMarca || ''" (ngModelChange)="filter.idItemMarca = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todas as marcas</option>
                    <option *ngFor="let marca of marcas" [ngValue]="marca.id">{{marca.nome}}</option>
                </select>         
            </div>  
            <div class="form-group col-12 col-md-4" *ngIf="configItem?.exibirLinha">
                <label for="filterItemLinha" class="col-form-label">Linha</label>
                <select class="form-control" name="filterItemLinha" id="filterItemLinha" 
                    [ngModel]="filter.idItemLinha || ''" (ngModelChange)="filter.idItemLinha = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todas as linhas</option>
                    <option *ngFor="let linha of linhas" [ngValue]="linha.id">{{linha.nome}}</option>
                </select>         
            </div>             
            <div class="form-group col-12 col-md-4" *ngIf="configItem?.exibirFamilia">
                <label for="filterItemFamilia" class="col-form-label">Família</label>
                <select class="form-control" name="filterItemFamilia" id="filterItemFamilia" 
                    [ngModel]="filter.idItemFamilia || ''" (ngModelChange)="filter.idItemFamilia = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todas as famílias</option>
                    <option *ngFor="let familia of familias" [ngValue]="familia.id">{{familia.nome}}</option>
                </select>         
            </div>
            <div class="form-group col-12 col-md-4" *ngIf="configItem?.exibirGrupo">
                <label for="filterItemGrupo" class="col-form-label">Grupo</label>
                <select class="form-control" name="filterItemGrupo" id="filterItemGrupo" 
                    [ngModel]="filter.idItemGrupo || ''" (ngModelChange)="filter.idItemGrupo = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todos os grupos de itens</option>
                    <option *ngFor="let grupo of grupos" [ngValue]="grupo.id">{{grupo.nome}}</option>
                </select>         
            </div>                         
            <div class="form-group col-12 col-md-4" *ngIf="configItem?.exibirSubgrupo">
                <label for="filterItemSubgrupo" class="col-form-label">Subgrupo</label>
                <select class="form-control" name="filterItemSubgrupo" id="filterItemSubgrupo" 
                    [ngModel]="filter.idItemSubgrupo || ''" (ngModelChange)="filter.idItemSubgrupo = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todos os subgrupos</option>
                    <option *ngFor="let subgrupo of subgrupos" [ngValue]="subgrupo.id">{{subgrupo.nome}}</option>
                </select>         
            </div>                                                 
        </div>


        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Segmentos</label>
                <sgt-classificacao-tipo-multiselect
                    [(idsClassificacoes)]="filter.idsClassificacoes"
                    (idsClassificacoesChange)="onChangeClassificacoes()"
                    [(nullOption)]="filter.classificacaoNull"
                    [showNullOption]="true"
                    [tipoClassificacaoCadastroItem]="true">
                </sgt-classificacao-tipo-multiselect>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md" *ngIf="isTipoMercadoUnidadeNegocio()">
                <label for="unidadeNegocioFilter" class="col-form-label">Unidades de Negócios</label>
                <sgt-unidade-negocio-multiselect
                    [(idsUnidadesNegocios)]="filter.idsUnidadesNegocios"
                    (idsUnidadesNegociosChange)="onChangeUnidadesNegocios()">
                </sgt-unidade-negocio-multiselect>
            </div>
            <div class="form-group col-12 col-md" *ngIf="configItem?.exibirMercado">
                <label for="mercadoFilter" class="col-form-label">Mercados</label>
                <sgt-mercado-multiselect
                    [(idsMercados)]="filter.idsMercados"
                    (idsMercadosChange)="onChangeMercados()"
                    [ativos]="true"
                    [inativos]="true"
                    [showNullOption]="true"
                    [(nullOption)]="filter.mercadoNull">
                </sgt-mercado-multiselect>
            </div>
            <div class="form-group col-12 col-md" *ngIf="configItem?.exibirNaturezaVenda">
                <label for="naturezaVendaFilter" class="col-form-label">Naturezas de Vendas</label>
                <sgt-natureza-venda-multiselect
                    [(idsNaturezasVendas)]="filter.idsNaturezasVendas"
                    (idsNaturezasVendasChange)="onChangeNaturezasVendas()"
                    [ativas]="true"
                    [inativas]="true"
                    [showNullOption]="true"
                    [(nullOption)]="filter.naturezaVendaNull">
                </sgt-natureza-venda-multiselect>
            </div>
            <div class="form-group col-12 col-md" *ngIf="configItem?.exibirTipo">
                <label for="itemTipoFilter" class="col-form-label">Tipos de Produtos</label>
                <sgt-item-tipo-multiselect
                    [(idsItensTipos)]="filter.idsItensTipos"
                    (idsItensTiposChange)="onChangeItensTipos()"
                    [showNullOption]="true"
                    [(nullOption)]="filter.itemTipoNull">
                </sgt-item-tipo-multiselect>
            </div>
            
            <!-- <div class="form-group col-12 col-md">
                <label for="filterLinhaProducao" class="col-form-label">Linha de Produção</label>
                <select class="form-control" name="filterLinhaProducao" id="filterLinhaProducao" 
                    [ngModel]="filter.idLinhaProducao || ''" (ngModelChange)="filter.idLinhaProducao = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todas as linhas de produção</option>
                    <option *ngFor="let linha of linhasProducao" [ngValue]="linha.id">{{linha.nome}}</option>
                </select>         
            </div> -->
        </div>          

        <div class="row" *ngIf="isTipoMercadoUnidadeNegocioComLinhaProducao()">
            <div class="form-group col-12">
                <label for="filterLinhaProducao" class="col-form-label">Linha de Produção</label>
                <select class="form-control" name="filterLinhaProducao" id="filterLinhaProducao" 
                    [ngModel]="filter.idLinhaProducao || ''" (ngModelChange)="filter.idLinhaProducao = $event ? $event : null; isFilterDirty = true">
                    <option value="">Todas as linhas de produção</option>
                    <option *ngFor="let linha of linhasProducao" [ngValue]="linha.id">{{linha.nome}}</option>
                </select>         
            </div>
        </div> 
    </div>
</div>


